<div class="container py-3">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10 text-start text-md-center px-4 px-md-5">
      <h2 class="f-24 f-lg-32 fw-bold text-primary mb-2">
        Paso 1: Gastos realizados
      </h2>

      <h3 class="f-18 f-lg-24 fw-bold mb-4">¡Comencemos {{ username }}!</h3>

      <p class="mb-5 px-lg-5 f-18 f-lg-24">
        Selecciona el tipo de gasto y agrega el monto de cada factura, uno por
        uno,
        <span class="fw-bold"
          >haciendo clic en el botón "<span class="fw-bolder f-30">+</span
          >"</span
        >.
      </p>

      <div class="px-md-5 mb-4 d-none d-md-block">
        <p class="f-16 text-center fw-normal">
          <span class="fw-bold"
            >Relaciona el tipo de gasto y suma los montos si cuentas con varias
            facturas del mismo tipo.</span
          >
          Ejemplo: si tienes varias facturas de medicamentos, selecciona la
          opción "Medicamentos" y suma los montos. Para agregar otros tipos, haz
          clic en el "+".
        </p>
      </div>

      <div
        class="p-3 mb-4 rounded text-start d-md-none"
        style="border: 1px solid #004686"
      >
        <p class="f-16 mb-0" style="color: #666; line-height: 1.4">
          <span class="fw-bold" style="color: #333"
            >Relaciona el tipo de gasto y suma los montos si cuentas con varias
            facturas del mismo tipo.</span
          >
          Ejemplo: si tienes varias facturas de medicamentos, selecciona la
          opción "Medicamentos" y suma los montos.
          <span class="fw-bold" style="color: #333"
            >Para agregar otros tipos, haz clic en el "+"</span
          >.
        </p>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div formArrayName="expenses">
          <div
            *ngFor="let fg of expenseForm.controls; index as i"
            [formGroupName]="i"
            class="row g-2 g-md-3 align-items-end mt-4"
          >
            <div class="col-12 col-md-6 col-lg-3 text-start">
              <label
                for="expenseType"
                class="form-label fw-bold d-block text-start text-primary"
                >Tipo de gasto</label
              >
              <select
                class="form-select"
                [class.bg-white]="!fg.disabled"
                formControlName="typeExpense"
              >
                <option value="">Selecciona</option>
                <option *ngFor="let t of expenseTypes" [value]="t.expenseName">
                  {{ t.expenseName }}
                </option>
              </select>
            </div>

            <div class="col-12 col-md-6 col-lg-3 text-start">
              <label
                for="invoiceDate"
                class="form-label fw-bold d-block text-start text-primary"
                >Fecha de la factura</label
              >
              <input
                type="date"
                class="form-control native-datepicker"
                [class.bg-white]="!fg.disabled"
                formControlName="dateExpense"
              />
            </div>

            <div
              class="col-12 text-start"
              [ngClass]="
                fg.disabled ? 'col-md-6 col-lg-3' : 'col-md-5 col-lg-2'
              "
            >
              <label
                for="currency"
                class="form-label fw-bold d-block text-start text-primary"
                >Moneda</label
              >
              <select
                class="form-select"
                [class.bg-white]="!fg.disabled"
                formControlName="currency"
                (change)="onCurrencyChange(i)"
              >
                <option value="">Selecciona</option>
                <option *ngFor="let cc of currencyCodes" [value]="cc">
                  {{ cc | uppercase }}
                </option>
              </select>
            </div>

            <div class="col-12 col-md-6 col-lg-3 text-start">
              <label
                for="invoiceValue"
                class="form-label fw-bold d-block text-start text-primary"
                >Valor de la factura</label
              >
              <input
                type="text"
                class="form-control"
                [class.bg-white]="!fg.disabled"
                formControlName="valueExpense"
                placeholder="0"
                (input)="onCurrencyInput($event, i)"
              />
            </div>

            <div
              *ngIf="!fg.disabled"
              class="col-md-1 d-none d-md-flex justify-content-center"
              [class.btn-group]="
                expenseFormLength > 1 && i === expenseFormLength - 1
              "
            >
              <button
                *ngIf="i > 0"
                type="button"
                class="btn btn-action f-lg-30 p-add"
                (click)="deleteExpense(i)"
                [class.btn-radius-left]="
                  expenseFormLength > 1 && i === expenseFormLength - 1
                "
              >
                -
              </button>

              <button
                *ngIf="i === expenseFormLength - 1 && expenseFormLength < 10"
                type="button"
                class="btn btn-action f-lg-30 p-add"
                (click)="addExpense()"
                [class.btn-radius-right]="i > 0"
              >
                +
              </button>
            </div>

            <div
              *ngIf="!fg.disabled"
              class="col-12 d-flex d-md-none justify-content-center gap-3 mt-4"
            >
              <button
                *ngIf="i > 0"
                type="button"
                class="btn btn-action d-flex align-items-center justify-content-center"
                style="width: 48px; height: 48px; border-radius: 8px"
                (click)="deleteExpense(i)"
              >
                <span class="fw-bold" style="font-size: 24px; line-height: 0"
                  >-</span
                >
              </button>

              <button
                *ngIf="i === expenseFormLength - 1 && expenseFormLength < 10"
                type="button"
                class="btn btn-action d-flex align-items-center justify-content-center"
                style="width: 48px; height: 48px; border-radius: 8px"
                (click)="addExpense()"
              >
                <span class="fw-bold" style="font-size: 24px; line-height: 0"
                  >+</span
                >
              </button>
            </div>
          </div>
        </div>

        <div class="pt-5 row justify-content-center m-0">
          <div class="col-12 col-md-auto px-0">
            <button
              type="submit"
              class="btn btn-action px-5 w-100 d-flex justify-content-center align-items-center"
              [disabled]="!canContinue() || loading"
            >
              Continuar
              <div *ngIf="loading" class="spinner-border ms-2"></div>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
